import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Opnunartímar — samkvæmt Heimsokn síðu
// Mán–Fim: 10:00–18:00, Fös: 10:00–17:00, Lau: 11:00–15:00, Sun: lokað
const SCHEDULE = [
  { open: 10, close: 18 }, // sunnudagur — lokað, en höldum til samræmis
  { open: 10, close: 18 }, // mánudagur
  { open: 10, close: 18 }, // þriðjudagur
  { open: 10, close: 18 }, // miðvikudagur
  { open: 10, close: 18 }, // fimmtudagur
  { open: 10, close: 17 }, // föstudagur
  { open: 11, close: 15 }, // laugardagur
];

function getNextOpening(now) {
  const d = new Date(now);
  for (let i = 0; i < 7; i++) {
    const check = new Date(d);
    check.setDate(d.getDate() + i);
    const day = check.getDay();
    // sunnudagur (0) er lokað
    if (day === 0) continue;
    const sched = SCHEDULE[day];
    // ef i===0, þá erum við að athuga daginn í dag — en við vitum að lokað er núna
    // svo við byrjum á næsta degi ef þetta er sama dagur
    const target = new Date(check);
    target.setHours(sched.open, 0, 0, 0);
    if (i === 0 && target.getTime() <= now.getTime()) continue;
    return { day: check, time: sched.open };
  }
  return { day: d, time: 10 };
}

const DAY_NAMES = ['sunnudag', 'mánudag', 'þriðjudag', 'miðvikudag', 'fimmtudag', 'föstudag', 'laugardag'];

function isOpen(now) {
  const day = now.getDay();
  if (day === 0) return false; // sunnudagur
  const sched = SCHEDULE[day];
  const h = now.getHours() + now.getMinutes() / 60;
  return h >= sched.open && h < sched.close;
}

export default function StoreStatusBadge() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  const open = isOpen(now);
  let label;
  if (open) {
    label = 'Opið núna';
  } else {
    const next = getNextOpening(now);
    const isTomorrow = next.day.getDate() !== now.getDate();
    const hourStr = String(next.time).padStart(2, '0') + ':00';
    if (isTomorrow) {
      label = `Opnar ${hourStr} á morgun`;
    } else {
      label = `Opnar kl. ${hourStr}`;
    }
  }

  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate('/heimsokn');
      }}
      className="inline-flex items-center gap-1.5 hover:opacity-70 transition-opacity"
      aria-label={`Verslun ${open ? 'opin' : 'lokuð'} — opna heimsókn`}
    >
      <span
        className={`block w-1.5 h-1.5 rounded-full ${open ? 'bg-green-600' : 'bg-muted-foreground'}`}
        aria-hidden="true"
      />
      <span className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.08em] text-muted-foreground">
        {label}
      </span>
    </button>
  );
}